<div>

<!-- <button class="noBordersBtn" (click)="openDialog()"><mat-icon>calendar_today</mat-icon></button>
-->

    <mat-calendar #calendar [(selected)]="selectedDate" 
    activeDate="closedDate"
    startView="multi-year"
    (click)="customCalClick($event)"
    (selectedChange)="dateChanged($event)">
    >														
    </mat-calendar> 
    <div><!-- bottom button bar -->
    <span style="padding-left:20px;">
        <button color="primary" mat-raised-button  (click)="customCalBtnTodayClick($event)">Today</button>&nbsp;</span>
    <button color="warn" mat-raised-button  (click)="customCalBtnClearClick($event)">Clear</button>&nbsp;
    <span style="float:right; padding-right:20px;">
    <button color="primary" mat-raised-button (click)="customCalBtnDoneClick($event)">Done</button></span>   

    </div>

    

</div>